import * as types from '../constants/swapRateConstants';
import config from './../config.js';
const initialState = {
  accSwapRateDetails:[],
  loadAccSwapDetNo:0,
  updateAccSwapRateNo:0
 // updateAccSwapFlag:false
};
const getAccSwapRateDetails=(details)=>{
  return details.map((item, index) => {
    item.Bid=(item.Bid).toLocaleString('en',{ minimumFractionDigits: 2, maximumFractionDigits:2 });
    item.Ask=(item.Ask).toLocaleString('en',{ minimumFractionDigits: 2, maximumFractionDigits:2 });
    item.MMM=(item.MMM).toLocaleString('en',{ minimumFractionDigits: 2, maximumFractionDigits:2 });
    return {
      ...item
    };
  });
}
const updateSwapRateDet= (msg) =>{
  let accData=JSON.parse(localStorage.getItem('TS')).ACD;
  let flag=false;
  //index = -1 : not found
  if(accData.findIndex(item => (item.C==msg.AC) ) !== -1){
    flag = true;
  }
  return flag;
}
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
     case types.GET_SWAP_RATE_DET:
      return{
        ...state,
      }
     case types.GET_SWAP_RATE_DET_SUCCESS:
      var randomNo=Math.floor((Math.random() * 100) + 1);
      return{
        ...state,
        accSwapRateDetails:getAccSwapRateDetails(action.result.data),
        loadAccSwapDetNo:randomNo
      }
      case types.GET_SWAP_RATE_DET_FAILURE:

      var randomNo=Math.floor((Math.random() * 100) + 1);
      return{
         ...state,
          accSwapRateDetails:getAccSwapRateDetails(action.result.data),
          loadAccSwapDetNo:randomNo
       }
       case types.UPDATE_SWAP_RATE_DET:
         var swapRandomNo=Math.floor((Math.random() * 100) + 1);
         return{
           ...state,
            updateAccSwapRateNo:swapRandomNo,
            //updateAccSwapFlag:updateSwapRateDet(action.msg)
         }
      // case types.RESET_STATE:
      //    return{
      //      ...initialState
      //    }
    default:
		    return state;
		}
  }
